export const transmissionPdfAction = {
  setPdfPages: (state, action) => {
    state.totalPdfPages = action.payload;
  },

  setPreviousReportPdfPages: (state, action) => {
    state.totalPreviousReportPdfPages = action.payload;
  },

  pageLoadSuccess: (state, action) => {
    state.allPagesLoadSuccess = action.payload;
  },

  setCurrentPage: (state, action) => {
    state.currentPageNumber = action.payload;
  },

  setPdfFileName: (state, action) => {
    state.pdfFileName = action.payload;
  },

  setTransmissionReportPdf: (state, action) => {
    state.transmissionReportPdf = action.payload;
  },

  setTransmissionReportPdfUrl: (state, action) => {
    state.transmissionReportPdfUrl = action.payload;
  },

  setPreviousReportPdfUrl: (state, action) => {
    state.previousReportPdfUrl = action.payload;
  },

  setIsTransmissionReportModified: (state, action) => {
    state.isTransmissionReportModified = action.payload;
  },

  setCoverPageLength: (state, action) => {
    state.coverPageLength = action.payload;
  },

  setIsFetchingCoverPage: (state, action) => {
    state.isFetchingCoverPage = action.payload;
  },
};
